import {
  elapsedYears,
  getAscaToday,
  isDateAfter,
  isDateBefore,
  isDateOnOrAfter,
} from "./date-utils";

export const getJuniorExpirationDate = (
  birthDate: Temporal.PlainDate
): Temporal.PlainDate => {
  const eighteenthBirthday = birthDate.add({ years: 18 });
  const showStart = Temporal.PlainDate.from({
    year: eighteenthBirthday.year,
    month: 6,
    day: 1,
  });
  const showEnd = Temporal.PlainDate.from({
    year: eighteenthBirthday.year + 1,
    month: 5,
    day: 31,
  });

  // TODO https://github.com/ASCAORG/asca-admin/issues/1166
  // Preserve the existing birthday-based eligibility behavior until it can be corrected separately.
  return isDateOnOrAfter(eighteenthBirthday, showStart) && isDateBefore(eighteenthBirthday, showEnd)
    ? eighteenthBirthday.add({ years: 1 })
    : eighteenthBirthday;
};

export const isJunior = (birthDate: Temporal.PlainDate): boolean =>
  isDateAfter(getJuniorExpirationDate(birthDate), getAscaToday());

export const isUnder16 = (birthDate: Temporal.PlainDate): boolean =>
  elapsedYears(birthDate, getAscaToday()) < 16;

export const isUnder18 = (birthDate: Temporal.PlainDate): boolean =>
  elapsedYears(birthDate, getAscaToday()) < 18;

export default {
  getJuniorExpirationDate,
  isJunior,
  isUnder16,
  isUnder18,
};
